import React from 'react'
import { Text } from '@theneatcompany/nui'
import { FormattedMessage } from 'react-intl'

import styles from '@/components/Layout/Layout.module.scss'
import Header from '@/components/Layout/Header'
import Card from '@/components/common/Card/Card'
import Footer from '@/components/Layout/Footer'
import Layout from '@/components/Layout/Layout'
import Link from '@/components/common/Link'
import { SUPPORT_OPTIONS } from '@/constants'

const PartnerLayout = () => (
  <div id="app-layout" className={styles.layout}>
    <div id="app-primary" className={styles.primary}>
      <div id="app-header" className={styles.header}>
        <Header />
      </div>

      <div id="app-main" className={styles.main}>
        <Layout.Content>
          <Card>
            <Card.Body>
              <Text size="small" element="p" color="foreground-secondary">
                <FormattedMessage
                  id="cannotManagedOnline"
                  values={{
                    email: (
                      <Link key="email" to={`mailto:${SUPPORT_OPTIONS.email}`} size="small">
                        {SUPPORT_OPTIONS.email}
                      </Link>
                    ),
                    managerName: SUPPORT_OPTIONS.manager,
                  }}
                />
              </Text>
            </Card.Body>
          </Card>
        </Layout.Content>
      </div>

      <div id="app-footer" className={styles.footer}>
        <Footer />
      </div>
    </div>
  </div>
)

export default PartnerLayout
